import { IncentivationDataType } from "./incentivationDataType";

export enum RewardCalculationType {
    DefinedBySubtypeCalculationType = "DefinedBySubtypeCalculationType",
    ManualInputCalculationType = "ManualInputCalculationType",
    MaxPointsCalculationType = "MaxPointsCalculationType",
    PercentMaxPointsCalculationType = "PercentMaxPointsCalculationType",
    SplitMaxPointsCalculationType = "SplitMaxPointsCalculationType",
    ScoreRangeCalculationType = "ScoreRangeCalculationType",
    FixedRewardCalculationType = "FixedRewardCalculationType",
    ScoreMultiplyRewardCalculationType = "ScoreMultiplyRewardCalculationType",
};

export interface BaseRewardCalculationType {
    type: RewardCalculationType;
    expectedIncentivationDataType?: IncentivationDataType;
};

export function isBaseRewardCalculationTypeModel(value: unknown): value is BaseRewardCalculationType {
    return (
        typeof value === "object" &&
        value !== null &&
        "type" in value &&
        Object.values(RewardCalculationType).includes((value as BaseRewardCalculationType).type)
    );
}

export interface ScoreRange {
    scoreFrom: number;
    scoreTo: number;
    pointsRewarded: number;
};
